function LoadingSpinner() {
    return (
        <div className="spinner-border text-primary align-middle text-center m-2" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
}

export default LoadingSpinner;
